export const DROPBOX_FOLDER_SYNC_QUERY_KEYS = {
  COMPANY_MEASUREMENT_DATE_BY_ATTIO_VALUATION_ID: 'company-measurement-date-by-attio-valuation-id',
} as const;

export const DROPBOX_FOLDER_SYNC_MESSAGES = {
  SEARCH_COMPANY_FOLDER_ERROR: 'Failed to search company folders in backup storage.',
  LIST_VALUATION_FOLDER_ERROR: 'Failed to list valuation folders in backup storage.',
  SET_COMPANY_FOLDER_FIRST: 'Set and sync Company Folder before listing valuation folders.',
  SET_COMPANY_FOLDER_BEFORE_VALUATION_SYNC: 'Set and sync Company Folder before syncing valuation folder.',
  ENTER_COMPANY_FOLDER_NAME_SYNC: 'Please enter a company folder name before syncing.',
  ENTER_VALUATION_FOLDER_NAME_SYNC: 'Please enter a valuation folder name before syncing.',
  LOADING_COMPANY_LINK: 'Loading company link, please wait…',
  COMPANY_LINK_FAILED:
    'Could not resolve Scalar company for this valuation. Try again in a moment or update the valuation status first.',
  MISSING_VALUATION_DATE_FOR_COMPANY_LINK:
    'Valuation date is missing or invalid. Cannot link company. Please fix the valuation in Attio.',
  FOLDER_NOT_IN_BACKUP: 'Folder does not exist in backup storage yet. Select an existing folder before syncing.',
  COMPANY_FOLDER_UPDATED: 'Company folder updated successfully',
  COMPANY_FOLDER_UPDATE_ERROR: 'Failed to update company folder. Please try again.',
  VALUATION_FOLDER_UPDATED: 'Valuation folder updated successfully',
  VALUATION_FOLDER_UPDATE_ERROR: 'Failed to update valuation folder. Please try again.',
  LOADING_MEASUREMENT_DATE: 'Loading measurement date information, please wait...',
  MEASUREMENT_DATE_NOT_LINKED: 'Unable to find measurement date for this valuation. Please ensure the valuation is linked to a measurement date.',
  MEASUREMENT_DATE_NOT_AVAILABLE: 'Measurement date ID not available. Please try refreshing the page.',
} as const;
